import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { WhatsAppNotificationService } from "@gtpl/shared-services/notification-management";
import { WhatsappBroadCastService } from "@gtpl/shared-services/whatsapp-broad-cast";
import { LocationAuditService } from "./location-audit.service";
import { LocationAuditController } from "./location-audit.controller";
import { LocationAudit } from "./entity/location-audit.entity";
import { LocationAuditAdapter } from "./location-audit.adapter";

@Module({
    imports: [
        TypeOrmModule.forFeature([LocationAudit]),
    ],
    controllers: [LocationAuditController],
    providers: [LocationAuditService,ApplicationExceptionHandler,WhatsAppNotificationService,WhatsappBroadCastService,LocationAuditAdapter],
    exports:[TypeOrmModule],
})

export class LocationAuditModule{}